import { contest } from './initializeStats';

export function sendStats(category, action, label, value) {
  if (value) {
    try {
      WP.stat.show(
        wp_sn,
        {
          category,
          label,
          value,
          asproduct,
          asorderid,
          asname,
        },
        action,
      );
    } catch (e) {
      console.log(`stat.show ERROR: ${e}`);
    }
  } else {
    try {
      WP.stat.show(
        wp_sn,
        {
          category,
          label,
          asproduct,
          asorderid,
          asname,
        },
        action,
      );
    } catch (e) {
      console.log(`stat.show ERROR: ${e}`);
    }
  }
}

export function linkStats() {
  document.querySelectorAll('[data-ga360-click]').forEach((el) => {
    const clickEvent = function (ev) {
      el.addEventListener(ev, function () {
        const eventCategory = this.getAttribute('data-ga360-click');
        const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
        let eventLabel;
        if (this.closest('.header')) {
          eventLabel = 'header';
        } else if (this.closest('.footer')) {
          eventLabel = 'footer';
        } else {
          eventLabel = window.location.href;
        }
        WP.push(() => {
          WP.pwp.customAction({
            ga: {
              event: 'site_interaction',
              eventCategory,
              eventAction,
              eventLabel,
            },
          });
        });

        sendStats(eventCategory, eventAction, eventLabel);
      });
    };
    clickEvent('click');
    clickEvent('auxclick');
    clickEvent('contextmenu');
  });
}

export function shareStats() {
  document.querySelectorAll('.__js_socialShare').forEach((el) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      const eventCategory = this.getAttribute('data-id');
      const href = this.getAttribute('data-href');
      const eventAction = 'ontouchstart' in document.documentElement ? 'tap' : 'click';
      let ga360Socials;
      let eventLabel;
      if (this.closest('.header')) {
        eventLabel = 'header';
      } else if (this.closest('.footer')) {
        eventLabel = 'footer';
      } else {
        eventLabel = window.location.href;
      }
      if (eventCategory === 'facebook') {
        window.open(
          href,
          '_blank',
          'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
        );
        ga360Socials = 'share_FB';
      }
      if (eventCategory === 'instagram') {
        window.open(
          href,
          '_blank',
          'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
        );
        ga360Socials = 'share_Instagram';
      }
      if (eventCategory === 'twitter') {
        window.open(
          href,
          '_blank',
          'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
        );
        ga360Socials = 'share_Twitter';
      }
      if (eventCategory === 'linkedin') {
        window.open(
          href,
          '_blank',
          'top=100, left=300, width=320,height=320,toolbar=1,resizable=0',
        );
        ga360Socials = 'share_Linkedin';
      }

      WP.push(() => {
        WP.pwp.customAction({
          ga: {
            event: 'site_interaction',
            eventCategory: ga360Socials,
            eventAction,
            eventLabel,
          },
        });
      });

      sendStats(eventCategory, eventAction, eventLabel);
    });
  });
}

export function setStatElementCollector() {
  document.querySelectorAll('[data-ga360-id]').forEach(function (el) {
    const artId = el.closest('article').getAttribute('data-id');
    const ga360id = el.getAttribute('data-ga360-id');
    if (ga360id === undefined) {
      console.log(
        `%c dodać ga360-id do Galerii hover: ${$(this).data('id')}`,
        'background: #553311; padding: 3px; color: #ffaaaa',
      );
    } else {
      contest.statElementCollector[`${ga360id}-${artId}`] = {
        id: ga360id,
        moduleName: el.getAttribute('data-id'),
        viewedCount: 0,
        itemCount: el.querySelectorAll('.widget__item').length,
      };
    }
    el.statVievedSlide = [];
    contest.slidePositionVieved[`${ga360id}-${artId}`] = {};
  });
}
